import { createContext } from "react";

export type AgGridContextType = {
    isInGrid: boolean;
    gridId: string;
    currentlyEditingCell?: string;
};

export const AgGridContext = createContext<AgGridContextType>({
    isInGrid: false,
    gridId: "",
    currentlyEditingCell: null,
});
